import { useEffect, useState, useContext } from "react";
import StatusIcons from "./content/outgoing/SubComponents/StatusIcons";
import Address from "./content/outgoing/SubComponents/Address";
import DocumentImage from "../documents/DocumentImage";
import CrudApi from "@serie3/common/api/crudApi";
import Spinner from "@serie3/freelancesplaceapi/Assets/img/spinner.gif";
import SettingsContext from "@serie3/common/auth/SettingsContext";
import formatAmount from "./formatAmount";

const InfoCard = ({ title, children }) => (
  <div style={{
    background: "#fff", borderRadius: "10px", padding: "14px 18px",
    boxShadow: "0 1px 6px rgba(0,0,0,0.07)", marginBottom: "12px",
  }}>
    {title && (
      <div style={{
        fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase",
        letterSpacing: "0.08em", color: "#9e9e9e", marginBottom: "10px",
      }}>
        {title}
      </div>
    )}
    {children}
  </div>
);

const DataRow = ({ label, value, bold }) => (
  <div style={{
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "5px 0", borderBottom: "1px solid #f5f5f5", fontSize: "0.88rem",
  }}>
    <span style={{ color: "#9e9e9e" }}>{label}</span>
    <span style={{ fontWeight: bold ? 800 : 600, color: bold ? "#c62828" : "#424242" }}>{value}</span>
  </div>
);

const BillIn = ({ bill, type }) => {
  const { settings } = useContext(SettingsContext);
  const locale = settings?.locale;
  const fmt = (n) => formatAmount(n, locale);

  const [file, setFile] = useState();

  useEffect(() => {
    const loadData = async () => {
      const response = await CrudApi.getBinary("/finance/in/" + type + "/filePreview/" + bill.id);
      setFile({ header: response.headers, data: response.data });
    };
    loadData();
  }, [bill]);

  return (
    <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>

      {/* Document preview */}
      <div style={{
        flex: "0 0 60%", background: "#fff", borderRadius: "10px",
        overflow: "auto", boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
        minHeight: "300px", display: "flex", alignItems: "center", justifyContent: "center", padding: "12px",
      }}>
        {file ? (
          <DocumentImage file={file} style={{ maxWidth: "100%", maxHeight: "100%" }} />
        ) : (
          <img src={Spinner} alt="Loading..." style={{ width: "40px" }} />
        )}
      </div>

      {/* Info sidebar */}
      <div style={{ flex: 1 }}>
        <InfoCard title="Status">
          <StatusIcons
            payed={bill.geldeingang}
            draft={bill.draft}
            subscription={bill.aborechnung}
            privateButton={bill.privat}
          />
        </InfoCard>

        <InfoCard title="Bill To">
          <Address addressJson={bill.fixed_address} style={{ margin: 0, fontSize: "0.88rem", lineHeight: 1.6 }} />
        </InfoCard>

        <InfoCard title="Dates">
          <DataRow label="Billing date" value={bill.datum} />
          <DataRow label="Subscription" value={bill.rechungsdatum} />
        </InfoCard>

        <InfoCard title="Amounts">
          <DataRow label="Net" value={`€ ${fmt(bill.netto)}`} />
          <DataRow label="Tax" value={`€ ${fmt(bill.brutto - bill.netto)}`} />
          <DataRow label="Gross" value={`€ ${fmt(bill.brutto)}`} bold />
        </InfoCard>
      </div>

    </div>
  );
};

export default BillIn;
